import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ToastrService } from 'ngx-toastr';
import { permissions } from '../../permissions';
import * as _ from 'lodash';

import { Page } from '../../model/page';
import { TableExtensionService } from '../oes/table-extension.service';
import { CustomerService } from '../../services/customer.service';
import { GridFiltersService } from '../../services/grid.filters.service';
import { Customer } from '../../model/customer';
import { Title } from '@angular/platform-browser';
import { NgxPermissionsService } from 'ngx-permissions';
import { AuthService } from '../../auth/auth.service';

@Component({
  templateUrl: 'customers.component.html',
  providers: [GridFiltersService],
})
export class CustomersComponent implements OnInit, OnDestroy {
  @ViewChild('actionbar') actionbar: ElementRef;
  @ViewChild('tableHeader') tableHeader: ElementRef;
  @ViewChild('tableFilter') tableFilter: ElementRef;
  @ViewChild('paginator') paginator: ElementRef;

  public loading = false;
  public permissions = permissions;
  private companies: Array<any> = [];
  public viewFilters: boolean;
  public scrollHeight = '75px';

  page = new Page();
  rows = new Array<Customer>();
  public cols = [];
  totalRecords = 0;

  private filters: { [key: string]: string } = {};
  private hasCustomerEdit = false;
  private hasCustomerAccess = false;
  isSuperAdmin = false;
  canCreateTradingPartner = false;

  constructor(
    private router: Router,
    private customerService: CustomerService,
    private toastr: ToastrService,
    private gridFiltersService: GridFiltersService,
    private title: Title,
    private tableExtensionService: TableExtensionService,
    private permissionsService: NgxPermissionsService,
    private authService: AuthService
  ) {
    this.page.pageNumber = 0;
    this.page.size = 50;
    this.title.setTitle('EDI - Customers');
  }

  ngOnInit() {
    this.viewFilters = true;
    this.loading = true;
    this.cols = [
      { field: 'CU1_ID', header: 'ID', visible: true, width: 50, sort: false },
      {
        field: 'CO1_ID',
        header: 'Company',
        visible: true,
        width: 80,
        sort: false,
      },
      {
        field: 'CU1_NAME',
        header: 'Customer Name',
        visible: true,
        width: 100,
        sort: false,
      },
      {
        field: 'CORP_ADDRESS_ID',
        header: 'Corp Addr ID',
        visible: true,
        width: 80,
        sort: false,
      },
      {
        field: 'CU1_SHOW_DEFAULT',
        header: 'Active',
        visible: true,
        width: 60,
        sort: false,
      },
      {
        field: 'CU1_TEST_MODE',
        header: 'Test Mode',
        visible: true,
        width: 60,
        sort: false,
      },
      {
        field: 'CU1_SEND_RECEIVE_EDI',
        header: 'Send/Receive EDI',
        visible: true,
        width: 100,
        sort: false,
      },
      {
        field: 'CU1_FILTERS',
        header: 'Connection Method',
        visible: true,
        width: 100,
        sort: false,
      },
      {
        field: 'CU1_MODIFIED_ON',
        header: 'Modified On',
        visible: true,
        width: 100,
        sort: false,
      },
      { field: 'CU1_MAP', header: 'Map', visible: true, width: 80, sort: true },
    ];
    this.page.filterParams = _.clone(this.filters);
    this.customerService.preloadData().subscribe((data) => {
      this.prepareData(data);
      this.setPage({ offset: 0 });
    });

    this.permissionsService
      .hasPermission(this.permissions.CUSTOMERS_ACCESS)
      .then((hasPermit) => {
        this.hasCustomerAccess = hasPermit;
      });

    this.permissionsService
      .hasPermission(this.permissions.CUSTOMERS_EDIT)
      .then((hasPermit) => {
        this.hasCustomerEdit = hasPermit;
      });

    this.permissionsService
      .hasPermission([this.permissions.ADMIN])
      .then((hasPermit) => {
        this.isSuperAdmin = hasPermit;
      });

    this.permissionsService
        .hasPermission([this.permissions.EDI_TRADING_PARTNER_ADD])
        .then((hasPermit) => {this.canCreateTradingPartner = hasPermit;
      });
  }

  ngOnDestroy() {

  }

  prepareData(data) {
    this.companies = data.companies.map((company) => {
      return {
        CO1_ID: company.CO1_ID,
        name: 'CO1_ID:' + company.CO1_ID,
        text: company.CO1_NAME,
      };
    });
  }


  getData() {
    this.loading = true;
    this.page.filterParams = _.clone(this.filters);
    this.setPage({ offset: this.page.pageNumber });
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;

    this.serverCall(this.page).subscribe(
      (result) => {
        this.rows = result.data;
        this.totalRecords = result.count;
        this.scrollHeight = this.getScrollHeight() + 'px';
        this.loading = false;
      },
      (error) => {
        console.log(error);
        this.loading = false;
        window.dispatchEvent(new Event('resize'));
        this.toastr.error('TimeOut occured', 'Service Error', {
          timeOut: 3000,
        });
      }
    );
  }

  onColumnResize(event) {
    this.tableExtensionService.onColumnResize(this.cols, event);
  }

  serverCall(page: Page): Observable<any> {
    return this.customerService.getCustomers(this.page);
  }

  editCustomer(record): void {
    this.router.navigate(['customers/edit/' + record.CU1_ID + '/' + record.CO1_ID]);
  }

  addCustomer(): void {
    this.router.navigate(['customers/add/0/' + this.authService.companyId]);
  }

  onSort(col) {
    if (col.sort) {
      if (this.filters.hasOwnProperty('SORT_COLUMN')) {
        if (this.filters['SORT_COLUMN'] === col.field) {
          if (this.filters['SORT_DIRECTION'] === 'ASC') {
            this.filters['SORT_DIRECTION'] = 'DESC';
          } else {
            this.filters['SORT_DIRECTION'] = 'ASC';
          }
        } else {
          this.filters['SORT_COLUMN'] = col.field;
          this.filters['SORT_DIRECTION'] = 'ASC';
        }
      } else {
        this.filters['SORT_COLUMN'] = col.field;
        this.filters['SORT_DIRECTION'] = 'ASC';
      }
      this.loading = true;
      this.page.pageNumber = 0;
      this.getData();
    }
  }

  onSubmit() {
    const filters = this.gridFiltersService.prepare(this.filters);

    let reload = false;
    const keys = Object.keys(filters).concat(
      Object.keys(this.page.filterParams)
    );
    for (const key of keys) {
      if (this.page.filterParams[key] !== filters[key]) {
        reload = true;
        break;
      }
    }

    if (reload) {
      this.page.filterParams = filters;
      this.getData();
    }
  }

  onPage(event) {
    this.page.size = event.rows;
    this.setPage({
      offset: event.first / event.rows,
    });
  }

  getScrollHeight(): number {
    return (
        this.getContentDialogHeight() -
        (this.tableHeader.nativeElement.offsetHeight +
        (this.paginator.nativeElement.offsetHeight + 55) +
        (this.viewFilters && this.tableFilter
            ? this.tableFilter.nativeElement.offsetHeight
            : 0))
    );
  }

  getContentDialogHeight(): number {
    return (
        window.innerHeight - (this.actionbar.nativeElement.offsetHeight + 48) - 77
    );
  }

  toggleFilterView() {
    const filters = _.clone(this.filters);
    let validFilterPresent = false;
    if (Object.keys(filters).length > 0) {
      for (const key of Object.keys(filters)) {
        if (filters[key] && key !== 'SORT_COLUMN' && key !== 'SORT_DIRECTION') {
          validFilterPresent = true;
        }
      }
    }
    if (!validFilterPresent) {
      this.viewFilters = !this.viewFilters;
      this.onWindowResize();
    }

    /*if(this.viewFilters){
      this.scrollHeight = '450px';
    } else {
      this.scrollHeight = '500px';
    }*/
  }

  cellDoubleClick(record) {
    if (this.hasCustomerEdit) {
      this.editCustomer(record);
    }
  }

  onWindowResize() {
    setTimeout(() => {
      this.scrollHeight = this.getScrollHeight() + 'px';
      window.dispatchEvent(new Event('resize'));
    }, 150);
  }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/customers/customers.component.ts